import { render, staticRenderFns } from "./CompletedOrders.vue?vue&type=template&id=43de3a0a&scoped=true"
import script from "./CompletedOrders.vue?vue&type=script&lang=js"
export * from "./CompletedOrders.vue?vue&type=script&lang=js"
import style0 from "./CompletedOrders.vue?vue&type=style&index=0&id=43de3a0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43de3a0a",
  null
  
)

export default component.exports